<template>
  <div :class="columnClassName">
    <column-header v-if="showColumnHeader" :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3>{{ device.name }}</h3>
        </div>
      </div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <div class="form-group">
                  <label for="name">{{ _('Name') }}</label>
                  <input type="text" class="form-control" id="deviceName" v-model="device.name" :disabled="device.subtype === 'seam'" :placeholder="_('Enter device name')">
                </div>
                <div class="form-group">
                  <label for="deviceIdentifier">{{ _('Identifier') }}</label>
                  <input type="text" disabled="disabled" class="form-control" id="deviceIdentifier" v-model="device.identifier">
                </div>
                <div class="form-group" v-if="origIdentifier">
                  <label for="origIdentifier">{{ _('Identifier') }} ({{ lock.properties.model.manufacturer_display_name }})</label>
                  <input type="text" disabled="disabled" class="form-control" id="origIdentifier" v-model="origIdentifier">
                </div>
                <template v-if="houseName">
                  <div class="form-group">
                    <label for="HouseName">{{ _('House name') }}</label>
                    <input readonly="true" id="HouseName" type="text" class="form-control" v-model="houseName" />
                  </div>
                  <div class="form-group">
                    <label for="battery">{{ _('Battery') }}</label>
                    <span id="battery">{{ Math.round(battery * 1000) / 10 }}%</span>
                    <template v-if="deviceLockStatus">
                      <label for="status">{{ _('Status') }}</label>
                      <span id="status">{{ formatLockStatus(deviceLockStatus) }}</span>
                      <button class="btn btn-xs" type="button" v-on:click="remoteOperate('lock')" :disabled="!isRemoteOperateEnabled"><i :class="'fa fa-fw fa-' + (isOperating ? 'spinner fa-spin' : 'lock')"></i> {{ _('verb|Lock') }}</button>
                      <button class="btn btn-xs" type="button" v-on:click="remoteOperate('unlock')" :disabled="!isRemoteOperateEnabled"><i :class="'fa fa-fw fa-' + (isOperating ? 'spinner fa-spin' : 'unlock')"></i> {{ _('Unlock') }}</button>
                      <label for="doorstate">{{ _('Door') }}</label>
                      <span id="doorstate">{{ formatDoorStatus(deviceDoorStatus) }}</span>
                    </template>
                  </div>
                </template>
                <template v-if="device.subtype === 'adax' && temperature.homename">
                  <div class="form-group">
                    <label for="HouseName">{{ _('House name') }}</label>
                    <input readonly="true" id="HouseName" type="text" class="form-control" v-model="temperature.homename" />
                  </div>
                  <div class="form-group">
                    <label for="targetTemperature">{{ _('Target temperature') }}</label>
                    <span id="targetTemperature">{{ Math.round(temperature.targetTemperature * 100) / 100 }}&#8451;</span>
                    <button class="btn btn-xs btn-default" v-on:click="setTargetTemperatureDialog" :disabled="settingTemperature"><i v-if="settingTemperature" class="fa fa-fw fa-spinner fa-spin"></i><template v-else>{{ _('Set') }}</template></button>
                    <label for="temperature">{{ _('Temperature') }}</label>
                    <span id="temperature">{{ Math.round(temperature.temperature * 100) / 100 }}&#8451;</span>
                    <label for="isHeating"><i class="fa fa-fw fa-heat" v-if="temperature.heatingEnabled"></i><i v-else class="fa fa-fw fa-power-off"></i> {{ temperature.heatingEnabled ? this._('Heating') : this._('Off') }}</label>
                  </div>
                </template>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">{{ _('Type') }}</label>
                  <p>
                    <i :class="'fa fa-fw fa-' + deviceTypeIcon"></i> {{ deviceSubType }}
                  </p>
                </div>
                <template v-if="device.subtype === 'seam' && lock.properties">
                  <div class="form-group">
                    <label for="devicetype">{{ _('Device') }}</label>
                    <p>
                      {{ lock.properties.model.manufacturer_display_name }}
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('resources')" class="tab-pane active" id="resources" v-if="isTabActive('resources')" key="resources">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Resources') }}</h3>
                <table class="table table-striped" v-if="device.sharedResource && device.sharedResource.length">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="resource in device.sharedResource">
                      <td style="cursor: pointer" v-on:click="displayResource(resource)">{{ resource.name }}</td>
                    </tr>
                  </tbody>
                </table>
                <p v-else>{{ _('This smart device is not currently linked to any resources.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('details')" class="tab-pane active" id="details" v-if="isTabActive('details')" key="details">
            <div class="row">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Details') }}</h3>
                <div class="form-group">
                  <label for="created">{{ _('Created') }}</label>
                  <input readonly="true" id="created" type="text" class="form-control" v-model="created" />
                </div>
                <div class="form-group" v-if="updated">
                  <label for="updated">{{ _('Updated') }}</label>
                  <input readonly="true" id="updated" type="text" class="form-control" v-model="updated" />
                </div>
                <div class="form-group" v-if="lockId">
                  <label for="LockID">{{ _('Lock ID') }}</label>
                  <input readonly="true" id="LockID" type="text" class="form-control" v-model="lockDeviceId" />
                </div>
                <div class="form-group" v-if="houseId">
                  <label for="HouseID">{{ _('House ID') }}</label>
                  <input readonly="true" id="HouseID" type="text" class="form-control" v-model="houseId" />
                </div>
                <div class="form-group" v-if="houseName">
                  <label for="HouseName">{{ _('House name') }}</label>
                  <input readonly="true" id="HouseName" type="text" class="form-control" v-model="houseName" />
                </div>
                <div class="form-group" v-if="lock.macAddress">
                  <label for="macAddress">{{ _('MAC Address') }}</label>
                  <input readonly="true" id="macAddress" type="text" class="form-control" v-model="lock.macAddress" />
                </div>
                <div class="form-group" v-if="lock.skuNumber">
                  <label for="skuNumber">{{ _('SKU number') }}</label>
                  <input readonly="true" id="skuNumber" type="text" class="form-control" v-model="lock.skuNumber" />
                </div>
                <div class="form-group" v-if="serialNumber">
                  <label for="SerialNumber">{{ _('Serial number') }}</label>
                  <input readonly="true" id="SerialNumber" type="text" class="form-control" v-model="serialNumber" />
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('users')" class="tab-pane active" id="users" v-if="isTabActive('users')" key="users">
            <div class="row">
              <div class="col-sm-12 leftcol">
                <button class="btn btn-success pull-right" type="button" v-on:click="createUserDialog">{{ _('Create new...') }}</button>
                <h3>{{ _('Users') }}</h3>
                <button class="btn btn-info" type="button" v-on:click="createRule">{{ _('Create rule') }}</button>
                <table class="table table-striped sortable" v-if="lock.users">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th><th>{{ _('Type') }}</th>
                    </tr>
                  </thead>
                  <tbody class="users" id="users">
                    <tr v-for="user in lock.users" class="user">
                      <td>{{ user.FirstName }} {{ user.LastName }}</td>
                      <td>{{ user.UserType }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('pincodes')" class="tab-pane active" id="pincodes" v-if="isTabActive('pincodes')" key="pincodes">
            <div class="row">
              <div class="col-sm-12 leftcol">
                <table class="table table-striped" v-if="device.ownPin && device.ownPin.length">
                  <thead>
                    <tr>
                      <th>{{ _('Code') }}</th>
                      <th>{{ _('Reservation') }}</th>
                      <th>{{ _('Synchronized') }}</th>
                      <th>{{ _('Validity') }}</th>
                    </tr>
                  </thead>
                  <tbody id="pincodes">
                    <tr v-for="pin in device.ownPin">
                      <td><strong>{{ pin.code }}</strong></td>
                      <td><button v-if="pin.reservation_id" class="btn btn-default btn-xs" type="button" v-on:click="displayReservationDialog(pin.reservation_id)"><i class="fa fa-fw fa-calendar"></i> {{ pin.reservation_id }}</button><template v-if="pin.reservation && pin.reservation.client_name">&nbsp;{{ pin.reservation.client_name }}</template></td>
                      <td>{{ pin.identifier ? _('Yes') : _('No') }}</td>
                      <td>{{ $filters.timestampToDate(pin.start_ts, locale) }} {{ $filters.timestampToTime(pin.start_ts, locale) }} - {{ $filters.timestampToDate(pin.end_ts, locale) }} {{ $filters.timestampToTime(pin.end_ts, locale) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-if="device.subtype === 'yale'">
              <div class="col-sm-12 leftcol">
                <h4>{{ _('All PIN codes in the lock') }}</h4>
                <table class="table table-striped sortable" v-if="lock.pins && lock.pins.loaded">
                  <thead>
                    <tr>
                      <th>{{ _('Code') }}</th>
                      <th>{{ _('User') }}</th>
                      <th>{{ _('Type') }}</th>
                    </tr>
                  </thead>
                  <tbody class="pins" id="pins">
                    <tr v-for="pin in lock.pins.loaded" class="pin">
                      <td>{{ pin.pin }}</td>
                      <td>{{ pin.firstName }} {{ pin.lastName }}</td>
                      <td>{{ formatAccessType(pin.accessType) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row" v-if="device.subtype === 'seam' && pinCodes.length">
              <div class="col-sm-12 leftcol">
                <h4>{{ _('All PIN codes in the lock') }}</h4>
                <table class="table table-striped sortable">
                  <thead>
                    <tr>
                      <th>{{ _('Code') }}</th>
                      <th>{{ _('User') }}</th>
                      <th>{{ _('Type') }}</th>
                      <th>{{ _('Status') }}</th>
                      <th>{{ _('Validity') }}</th>
                    </tr>
                  </thead>
                  <tbody class="pins" id="pins">
                    <tr v-for="pin in pinCodes" class="pin">
                      <td>{{ pin.code }}</td>
                      <td>{{ pin.name }}</td>
                      <td>{{ formatAccessType(pin.type) }}</td>
                      <td>{{ formatPinStatus(pin.status) }}</td>
                      <td><template v-if="pin.starts_at">{{ DateTime.fromISO(pin.starts_at).toFormat(dateFormat + ' ' + timeFormat) }} - {{ DateTime.fromISO(pin.ends_at).toFormat(dateFormat + ' ' + timeFormat) }}</template></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('sharing')" class="tab-pane active" id="sharing" v-if="isTabActive('sharing')" key="sharing">
            <div class="row">
              <div class="col-sm-12 leftcol">
                <h3>{{ _('Sharing') }}</h3>
                <p>{{ _('Select the shops that are allowed to use this device.') }}</p>
              </div>
              <div class="col-sm-6 leftcol">
                <div class="list-group">
                  <span v-for="shopId in allowedShopIds" class="list-group-item">
                    <h4 class="list-group-item-heading" style="margin-top: 8px">
                      <span>{{ shopId }}</span>
                      <span class="fa fa-fw fa-close" v-on:click="removeAllowedShopId(shopId)" style="cursor: pointer"></span>
                    </h4>
                  </span>
                </div>
                <div class="form-group">
                  <button class="btn btn-success" type="button" v-on:click="addAllowedShopIdDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add') }}</button>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <template v-if="device.subtype === 'seam'">
            <button class="btn btn-danger" v-if="!parseInt(device.deleted)" v-on:click="convertDeviceToUnmanaged"><i class="fa fa-fw fa-trash"></i> {{ _('Convert to unmanaged') }}</button>
            <button class="btn btn-success" v-else v-on:click="convertDeviceToManaged"><i class="fa fa-fw fa-link"></i> {{ _('Convert to managed') }}</button>
          </template>
          <div class="pull-right">
            <button class="btn btn-default" type="button" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import components from '~/lib/components'
import notifications from '~/lib/notifications'
import { ModalReservationDetails as ReservationDetails } from '#components'

export default {
  data () {
    return {
      device: {},
      lock: {},
      pinCodes: [],
      temperature: {},
      settingTemperature: false,
      isOperating: false,
      DateTime: DateTime
    }
  },
  mixins: [components, notifications],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'general', label: this._('General') },
        { id: 'resources', label: this._('Resources') },
        { id: 'details', label: this._('Details'), hidden: !(this.device.subtype === 'yale' || this.device.subtype === 'seam') },
        { id: 'users', label: this._('Users'), hidden: this.device.subtype !== 'yale' },
        { id: 'pincodes', label: this._('PIN codes'), hidden: !(this.device.subtype === 'yale' || this.device.subtype === 'seam' || (this.device.type === 'lock' && this.device.ownPin && this.device.ownPin.length)) },
        { id: 'sharing', label: this._('Sharing'), hidden: !((this.device.subtype === 'seam' || this.device.subtype === 'seamacs') && !this.device.origin) }
      ])
    },
    ...mapGetters(['baseDomain', 'shopId', 'version', 'locale']),
    allowedShopIds () {
      return this.device.shopids ? this.device.shopids.split(',') : []
    },
    origIdentifier () {
      if (!this.lock || !this.device || this.device.subtype !== 'seam') {
        return null
      }
      switch (this.lock.device_type) {
        case 'igloohome_lock':
          return this.lock.properties && this.lock.properties.igloohome_metadata && this.lock.properties.igloohome_metadata.device_id ? this.lock.properties.igloohome_metadata.device_id : null
        case 'yale_lock':
          return this.lock.properties && this.lock.properties.august_metadata && this.lock.properties.august_metadata.lock_id ? this.lock.properties.august_metadata.lock_id : null
      }
      return null
    },
    deviceTypeIcon () {
      if (!this.device) {
        return ''
      }
      switch (this.device.type) {
        case 'lock':
          if (this.device.subtype === 'seamacs') {
            return 'house-lock'
          }
          return 'lock'
        case 'temperature':
          return 'temperature-list'
      }
      return 'house-signal'
    },
    deviceSubType () {
      if (!this.device) {
        return ''
      }
      switch (this.device.subtype) {
        case 'seam':
          return this._('Seam')
        case 'seamacs':
          return this._('Seam ACS')
        case 'adax':
          return this._('Adax')
        case 'yale':
          return this._('Yale')
        case 'ratna':
          return this._('Ratna')
        case 'igloo':
          return this._('Igloohome')
      }
      return this.device.subtype
    },
    created: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.created_at ? DateTime.fromISO(this.lock.created_at).toFormat(this.dateFormat + ' ' + this.timeFormat) : null
        }
        return this.lock.Created ? DateTime.fromISO(this.lock.Created).toFormat(this.dateFormat + ' ' + this.timeFormat) : null
      },
      set () {}
    },
    updated: {
      get () {
        return this.lock && this.lock.Updated ? DateTime.fromISO(this.lock.Updated).toFormat(this.dateFormat + ' ' + this.timeFormat) : null
      },
      set () {}
    },
    lockDeviceId: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.device_id
        }
        return this.lock.LockID
      },
      set () {}
    },
    houseId: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties?.august_metadata?.house_id
        }
        return this.lock.HouseID
      },
      set () {}
    },
    houseName: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties?.august_metadata?.house_name
        }
        return this.lock.HouseName
      },
      set () {}
    },
    battery: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties?.battery_level
        }
        return this.lock.battery
      },
      set () {}
    },
    serialNumber: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties?.serial_number
        }
        return this.lock.SerialNumber
      },
      set () {}
    },
    deviceLockStatus: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties.locked ? 'locked' : 'unlocked'
        }
        return this.lock.LockStatus.status
      },
      set () {}
    },
    deviceDoorStatus: {
      get () {
        if (!this.lock) {
          return null
        }
        if (this.device.subtype === 'seam') {
          return this.lock.properties.door_open ? 'opened' : 'closed'
        }
        return this.lock.LockStatus.doorState
      },
      set () {}
    },
    isRemoteOperateEnabled () {
      return !this.isOperating
    }
  },
  methods: {
    addAllowedShopIdDialog () {
      this.showDialog({
        title: this._('Select a shop'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            icon: 'check',
            class: 'success',
            requiredFields: ['shopId'],
            handler: (data) => {
              this.device.shopids = this.device.shopids
                ? [...new Set(this.device.shopids.split(',').concat(data.shopId))]
                    .filter(id => id && id.trim())
                    .sort()
                    .join(',')
                : data.shopId
            }
          }
        ],
        fields: [
          {
            title: this._('Shop ID'),
            type: 'text',
            name: 'shopId'
          }
        ]
      })
    },
    removeAllowedShopId (shopId) {
      this.device.shopids = this.device.shopids.split(',').filter(id => id !== shopId).join(',')
    },
    displayResource (resource) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ResourceDetails',
        title: this._('Resource') + ' ' + resource.id + (resource.name ? ': ' + resource.name : ''),
        width: 6,
        data: {
          resourceId: resource.id,
          trail: this.componentTrail
        }
      })
    },
    formatLockStatus (status) {
      switch (status) {
        case 'locked':
          return this._('Locked')
        case 'unlocked':
          return this._('Unlocked')
      }
      return status
    },
    formatDoorStatus (status) {
      switch (status) {
        case 'open':
        case 'opened':
          return this._('Opened')
        case 'closed':
          return this._('Closed')
      }
      return status
    },
    formatAccessType (type) {
      switch (type) {
        case 'always':
        case 'ongoing':
          return this._('Always')
        case 'temporary':
        case 'time_bound':
          return this._('Temporary')
      }
      return type
    },
    formatPinStatus (status) {
      switch (status) {
        case 'unset':
          return this._('Awaiting')
        case 'setting':
          return this._('Setting')
        case 'set':
          return this._('Active')
        case 'removing':
          return this._('Removing')
        case 'unknown':
          return this._('Unknown')
      }
      return status
    },
    setTargetTemperatureDialog () {
      this.showDialog({
        title: this._('Target temperature'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            requiredFields: ['temperature'],
            handler: (data) => {
              this.setTargetTemperature(data.temperature)
            }
          }
        ],
        fields: [
          {
            title: this._('Temperature'),
            type: 'number',
            name: 'temperature',
            defaultValue: this.temperature.targetTemperature
          }
        ]
      })
    },
    async setTargetTemperature (temperature) {
      this.settingTemperature = true
      const data = {
        id: this.device.identifier,
        temperature
      }
      try {
        await axios.patch(this.baseDomain + this.shopId + '/adaxtemperatures/' + this.device.identifier + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.settingTemperature = false
        return this.showError(e)
      }
      await this.loadTemperature(this.device.identifier)
      this.settingTemperature = false
    },
    getSaveData () {
      const exportFields = [
        'id',
        'name',
        'shopids'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.device[e], a), {})
      return data
    },
    async doRemove () {
      try {
        await axios.delete(this.baseDomain + this.shopId + '/smartdevices/' + this.device.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return this.showError(e)
      }
      this.close()
    },
    displayReservationDialog (id) {
      if (id) {
        this.showModal('smartdevicereservationdetails', ReservationDetails, {
          props: {
            baseDomain: this.baseDomain,
            shopId: this.shopId,
            apiKey: this.apiKey,
            component: {
              initData: {
                reservationId: id,
                modal: true
              }
            }
          },
          events: {},
          handlers: {},
          width: 1000
        })
      }
    },
    createUserDialog () {
      this.showDialog({
        title: this._('Create User'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Create'),
            class: 'success',
            icon: 'check',
            requiredFields: ['FirstName', 'LastName'],
            handler: this.createUser
          }
        ],
        fields: [
          {
            title: this._('First name'),
            type: 'text',
            name: 'FirstName'
          },
          {
            title: this._('Last name'),
            type: 'text',
            name: 'LastName'
          },
          /*
          {
            title: this._('Email'),
            type: 'text',
            name: 'Email'
          },
          {
            title: this._('Phone'),
            type: 'text',
            name: 'PhoneNo'
          },
          */
        ]
      })
    },
    async createUser (data) {
      let response
      data.LockID = this.lock.LockID
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      console.log(response)
      this.showNotification(this._('User created!'))
    },
    async createRule () {
      const data = {
        UserID: 'f999d60e-1aa4-4a18-9bcb-494c2cbb29b3',
        LockID: '5214045745DD83D4E418A839660C4B81',
        FirstName: 'Esa',
        LastName: 'Kumikola',
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/yaleusers.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      console.log(response)
    },
    async remoteOperate (action) {
      this.isOperating = true
      const data = {
        id: this.lockDeviceId,
        action
      }
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/' + this.device.subtype + 'locks/' + this.lockDeviceId + '.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.isOperating = false
        return this.showError(e)
      }
      if (response && response.data && response.data.info) {
        this.showNotification(this.getRemoteOperateSuccessMessage(action, response.data.info.lockStatusChanged))
      }
      this.isOperating = false
      this.loadLock(this.lockDeviceId)
    },
    getRemoteOperateSuccessMessage (action, statusChanged) {
      switch(action) {
        case 'lock':
          return statusChanged ? this._('Door locked.') : this._('The door was already locked.')
        case 'unlock':
          return statusChanged ? this._('Door unlocked.') : this._('The door was already unlocked.')
        default:
          return ''
      }
    },
    async save () {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/smartdevices/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          return
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadSmartDevice(response.data.id)
      }
      this.saving = false
      this.saved = true
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.layout)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadSmartDevice (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/smartdevices/' + id + '.json?pincodes=true&resources=true&apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          reject()
          this.loading = false
          return
        }
        this.device = response.data
        if (this.device.data) {
          this.data = JSON.parse(this.device.data)
        }
        if (!parseInt(this.device.deleted, 10)) {
          if (this.device.subtype === 'yale' || this.device.subtype === 'seam') {
            await this.loadLock(response.data.identifier)
          }
          if (this.device.subtype === 'seam' || this.device.subtype === 'seamacs') {
            await this.loadPinCodes(response.data.identifier)
          }
          if (this.device.subtype === 'adax') {
            await this.loadTemperature(response.data.identifier)
          }
        }
        this.storeState()
        this.loading = false
        resolve(this.device)
      })
    },
    loadLock (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + this.device.subtype + 'locks/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e, null, true)
          return
        }
        this.lock = response.data
        this.storeState()
        this.loading = false
        resolve(this.lock)
      })
    },
    loadPinCodes (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + this.device.subtype + 'locks/' + id + '.json?codes=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e, null, true)
          return
        }
        this.pinCodes = response.data
        this.storeState()
        this.loading = false
        resolve(this.pinCodes)
      })
    },
    loadTemperature (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + this.device.subtype + 'temperatures/' + id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          this.loading = false
          this.showError(e, null, true)
          return
        }
        this.temperature = response.data
        this.storeState()
        this.loading = false
        resolve(this.heater)
      })
    },
    async convertDeviceToUnmanaged () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/' + this.device.subtype + 'locks/' + this.device.identifier + '.json?apikey=' + this.apiKey, {
          id: this.device.identifier,
          is_managed: false
        })
      } catch(e) {
        this.showError(e)
      }
      this.close()
    },
    async convertDeviceToManaged () {
      try {
        await axios.patch(this.baseDomain + this.shopId + '/' + this.device.subtype + 'locks/' + this.device.identifier + '.json?apikey=' + this.apiKey, {
          id: this.device.identifier,
          is_managed: true
        })
      } catch(e) {
        this.showError(e)
      }
      this.close()
    }
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadSmartDevice(this.component.initData.deviceId)
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['smartdeviceUpdate'] = async (message) => {
        if (message && message.data && this.device && parseInt(message.data.id, 10) === parseInt(this.device.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadSmartDevice(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.device && this.device.id && parseInt(this.device.id, 10) !== parseInt(this.component.initData.deviceId, 10)) {
        try {
          await this.loadSmartDevice(this.component.initData.deviceId)
        } catch(e) {}
      }
    }
  }
}
</script>